import React, { ReactElement } from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import globalStyles from "../../../../assets/styles/global.module.scss";
import style from "../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";

interface CarouselVariableTableProps {
    tableBodyContent: ReactElement,
} 

const CarouselVariableTable: React.FC<CarouselVariableTableProps> = (props) => {
    
    const { tableBodyContent } = props;

    return (
        <>
            <TableContainer className={`${globalStyles.fullwidth} ${globalStyles.maxWidthFull} ${globalStyles.boxSizingBorderBox} ${globalStyles.overflowAuto}`}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell className={style.tableHeadingFontStyle}></TableCell>
                            <TableCell className={style.tableHeadingFontStyle}>Field Type</TableCell>
                            <TableCell className={style.tableHeadingFontStyle}>Field</TableCell>
                            <TableCell className={style.tableHeadingFontStyle}>Static Value</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableBodyContent}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

export default CarouselVariableTable
